module.exports = __webpack_public_path__ + "img/urbi-05.b8e02b74.jpg";